import { Button, CircularProgress, ThemeProvider, Tooltip, useTheme } from "@mui/material";
import { errorTheme } from "utils/Themes";

import DeleteIcon from '@mui/icons-material/Delete';

const DeleteButton = props => {

    const {
        title = "",
        isLoading = false,
        ...others
    } = props;

    const theme = useTheme();

    return (
        <ThemeProvider
            theme={errorTheme}
        >
            <Tooltip
                title={title}
                arrow
            >
                <Button
                    color="primary"
                    variant={"contained"}
                    style={{
                        minWidth: "2.2em",
                        minHeight: "2.2em",
                        margin: theme.spacing(.5),
                        padding: 0
                    }}
                    {...others}
                >
                    {isLoading ? (
                        <CircularProgress
                            size={20}
                            style={{
                                color: "white"
                            }}
                        />
                    ) : (
                        <DeleteIcon
                            fontSize={"small"}
                        />
                    )}
                </Button>
            </Tooltip>
        </ThemeProvider>
    );
}

export default DeleteButton;